/** Shared sign-in link copy log prefix (no client/server logger imports). */
export const SIGN_IN_LINK_COPY_LOG_PREFIX = '[SignInLinkCopy]';
